<template>
<div>
    <nav class="navbar navbar-expand-md navbar-div fixed-left hidden-sm-and-down">
      <router-link to="/" class="navbar-brand pb-5">
        <img src="../assets/images/logo_myiptv.png" class="img-fluid" />
        <span class="align-items-end text-white" id="text_logo"> IPTV</span>
      </router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation" v-on:click="toggleNavbar">
        <img src="../assets/images/logo_myiptv.png" class="img-fluid" width="50" height="50" /> 
    </button>

    <div class="collapse navbar-collapse" id="navbarsExampleDefault" v-bind:class="{ 'show': show }">
        <ul class="navbar-nav">
            <transition name="slide-fade" v-if ="tv != null" > 
              <info-tv-menu v-show="showInfoTv == true"  :tv="tv" :currentProgram="currentProgram" :futureProgram="futureProgram"/>
            </transition>

            <hr class="hr-iptv m-0">
            <li class="nav-item">
              <router-link to="/list/live">
                <a class="nav-link">
                    <figure class="figure d-flex justify-content-start align-items-center">
                        <img src="../assets/images/icona_live_tv_menu.png" class="img-fluid" width="60" height="60"> 
                        <figcaption class="figure-caption text-li">LIVE</figcaption>
                    </figure>
                </a>
              </router-link>
            </li>
            <hr class="hr-iptv m-0">
            <li class="nav-item">
              <router-link to="/prossimi-tg">
                <a class="nav-link">
                    <figure class="figure d-flex justify-content-start align-items-center">
                        <img src="../assets/images/icona_prossimi_tg.png" class="img-fluid" width="60" height="60"> 
                        <figcaption class="figure-caption text-li">I PROSSIMI TG</figcaption>
                    </figure>
                </a>
              </router-link>
            </li>
             <hr class="hr-iptv m-0">
            <li class="nav-item">
              <router-link to="/search-territorio">
                <a class="nav-link">
                    <figure class="figure d-flex justify-content-start align-items-center">
                        <img src="../assets/images/icona_territorio.png" class="img-fluid" width="60" height="60"> 
                        <figcaption class="figure-caption text-li">CERCA NEL TERRITORIO</figcaption>
                    </figure>
                </a>
              </router-link>
            </li>
            <hr class="hr-iptv m-0">
            <li class="nav-item">
              <router-link to="/presto-online">
                <a class="nav-link">
                    <figure class="figure d-flex justify-content-start align-items-center">
                        <img src="../assets/images/icona_mylife.png" class="img-fluid" width="60" height="60"> 
                        <figcaption class="figure-caption text-li">LE MIE REGISTRAZIONI MYLIFE</figcaption>
                    </figure>
                </a>
              </router-link>
            </li>
            
        </ul>
      </div>
    </nav>

</div>

</template>

<script>

///import { mapState, mapActions, mapGetters } from 'vuex'
import InfoTvMenu from '@/components/InfoTvMenu.vue'

export default {
  name: 'SideMenu',
  components: {
    InfoTvMenu
  },
  data() {
    return {
      show: true
    }
  },
  props:['currentProgram','futureProgram','tv','showInfoTv'],
  methods: {
    toggleNavbar() {
      this.show = !this.show;
      this.navbarOpen = !this.navbarOpen;
    }
  }
};

</script>

<style scoped>
#text_logo{
    font-weight:bold;
    font-size:36px;
}

.text-li{
    font-size:18px;
    font-weight:bold;
    color:white;
}

.hr-iptv{
    background:#00ADEE;
    height: 1px;
    width: 100%;
    
}

body {
  padding-top: 90px;
}

@media (min-width: 768px) {
  body {
    padding-top: 0;
  }
}

@media (min-width: 768px) {
  body {
    margin-left: 232px;
  }
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

</style>
